import React from 'react';
import ReactDOM from 'react-dom';
import App from '@elevio/kb-kit/lib/App';
import config from './config';
import './css/main.css';
const target = document.getElementById('kb-target');
if (!target)
    throw new Error('Cant find target div');
if (!document.title.trim()) {
    document.title = 'Code Connect';
}
if (process.env.NODE_ENV === 'development') {
    React.StrictMode = React.Fragment;
    import('@axe-core/react').then((axe) => {
        axe.default(React, ReactDOM, 1000);
    });
}
ReactDOM.render(<App config={config}/>, target);
